export default {
  RX_ENTRY: 'RX_ENTRY',
  TRANSFER_REQUEST: 'TRANSFER_REQUEST',
};

export const PrescriptionReviewStatus = {
  DIRECTION_REVIEW: 'PRESCRIPTION_DIRECTION_REVIEW',
  DUPLICATE_REVIEW: 'PRESCRIPTION_DUPLICATE_REVIEW',
  DRUG_PROFILE_REVIEW: 'DRUG_PROFILE_REVIEW',
  PRESCRIPTION_REVIEW: 'PRESCRIPTION_REVIEW',
  MULTI_RX_REVIEW: 'MULTI_RX_REVIEW',
  SHIP_LATER_REVIEW: 'SHIP_LATER_REVIEW',
  SHIPPING_ADDRESS_REVIEW: 'SHIPPING_ADDRESS_REVIEW',
  PROVIDER_CLARIFICATION_REVIEW: 'PROVIDER_CLARIFICATION_REVIEW',
  MANUAL_ORDER_REVIEW: 'MANUAL_ORDER_REVIEW',
  OTHER_REVIEW: 'OTHER_REVIEW',
  COMPOUNDING_STATE_NOT_LICENSED_REVIEW: 'COMPOUNDING_STATE_NOT_LICENSED_REVIEW',
};

/**
 * Review reasons a line item carries while it is routed to Central Fill. Central Fill keeps acting
 * on the order the item was submitted under, so the UI blocks local actions that would move the
 * item off that order under these reasons — Cannot Fill (POM-6317) among them.
 */
export const CENTRAL_FILL_REVIEW_REASONS = [
  'COMPOUNDING_REVIEW',
  PrescriptionReviewStatus.COMPOUNDING_STATE_NOT_LICENSED_REVIEW,
];

export const NON_SELECTABLE_REVIEW_REASONS = [
  PrescriptionReviewStatus.DUPLICATE_REVIEW,
  PrescriptionReviewStatus.COMPOUNDING_STATE_NOT_LICENSED_REVIEW,
];

export const PrescriptionReviewStatusName = {
  DIRECTION_REVIEW: 'DIRECTION_REVIEW',
  DUPLICATE_REVIEW: 'DUPLICATE_REVIEW',
  DRUG_PROFILE_REVIEW: 'DRUG_PROFILE_REVIEW',
  PRESCRIPTION_REVIEW: 'PRESCRIPTION_REVIEW',
  MULTI_RX_REVIEW: 'MULTI_RX_REVIEW',
  SHIP_LATER_REVIEW: 'SHIP_LATER_REVIEW',
  SHIPPING_ADDRESS_REVIEW: 'SHIPPING_ADDRESS_REVIEW',
  PROVIDER_CLARIFICATION_REVIEW: 'PROVIDER_CLARIFICATION_REVIEW',
  MANUAL_ORDER_REVIEW: 'MANUAL_ORDER_REVIEW',
  OTHER_REVIEW: 'OTHER_REVIEW',
};

/**
 * Why an order was sent to Direction Review. Recorded when the review is raised, so the screen can
 * offer the resolution that fits. Reviews raised before this was recorded carry no reason, so every
 * consumer has to render without one.
 */
export const DirectionReviewReason = {
  NEW_DIRECTION: 'NEW_DIRECTION',
  SIG_RETIRED: 'SIG_RETIRED',
  NOT_APPROVED_FOR_DRUG: 'NOT_APPROVED_FOR_DRUG',
  AMBIGUOUS_DIRECTION: 'AMBIGUOUS_DIRECTION',
  NO_CATALOG_ITEM: 'NO_CATALOG_ITEM',
};
